import React, { useState } from 'react';
import Layout from '@codedrop/layout/esm/layout';
import Heading from '@codedrop/typography/esm/heading';
import setHTML from '@codedrop/utils/esm/utils';
import Modal from '@codedrop/modal/esm/modal';
import Form from '@codedrop/form/esm/form-dynamic';

const AltCta = ({
  cta
}) => {
  const [modalState, setModalState] = useState(false);
  return /*#__PURE__*/React.createElement(Layout, {
    className: "section--top-l"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cta cta--alt background--blue-10 background--firework-left text--centered",
    id: cta.id
  }, /*#__PURE__*/React.createElement(Heading, {
    tag: "h2",
    headingClass: "heading--s heading--context text--centered"
  }, cta.title), /*#__PURE__*/React.createElement(Heading, {
    tag: "h3",
    headingClass: "heading--xxxl heading--special"
  }, cta.subTitle), /*#__PURE__*/React.createElement(Modal, {
    buttonText: cta.buttonText,
    title: cta.modalContent.modalTitle,
    modalState: modalState,
    setModalState: setModalState,
    id: "cta-modal-".concat(cta.modalContent.formName)
  }, /*#__PURE__*/React.createElement(Form, {
    modifierClass: cta.modalContent.formModifierClass,
    formName: cta.modalContent.formName,
    formSubmitText: cta.modalContent.formSubmitText,
    formFields: cta.modalContent.formFields,
    formSuccess: cta.modalContent.formSuccess,
    formFail: cta.modalContent.formFail,
    callBack: () => {
      setModalState(false);
    }
  })), /*#__PURE__*/React.createElement("p", null, setHTML(cta.description))));
};

AltCta.displayName = 'Cta';
export default AltCta;